import "../../style/base.css";
import "../../badge/index.css";
import "../../icon/index.css";
import "../../sticky/index.css";
import "../../swipe/index.css";
import "../../swipe-item/index.css";
import "../../tabs/index.css";
import "../../tab/index.css";
import "../index.css";
